/* 
https://deltener.com/blog/nuxt-third-party-code-is-poison/#the-turtle-loads-a-script-after-page-load-and-runs-a-callback
The Turtle: Loads a script after page load and runs a callback
 * callback - the function to run after onLoad
 * delay - wait X milliseconds after onLoad
*/
export const onLoad = (callback, delay = 1) => {
  // missed the load event, run now
  if (document.readyState === 'complete') {
    setTimeout(() => callback(), delay);
  } else {
    window.addEventListener('load', function () {
      setTimeout(() => callback(), delay);
    });
  }
};
